import * as React from 'react';
import * as styles from './common.module.scss';
import { Button } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';

interface Props extends ButtonProps {
  text: string;
  title?: string;
  deactive?: boolean;
  styles?: any;
  handleClick: (event?) => void;
  preventDefault?: boolean;
  component?: any;
}
const SecondaryButton = ({
  text,
  title,
  deactive,
  styles: extraStyles,
  handleClick,
  component,
  preventDefault,
  ...rest
}: Props) => {
  return (
    <Button
      {...rest}
      title={title}
      className={deactive ? styles.deactive : styles.secondaryButton}
      onClick={event => {
        if (preventDefault === undefined || preventDefault) {
          event.preventDefault();
        }
        handleClick();
      }}
      variant="contained"
      color="primary"
      disabled={deactive}
      style={extraStyles}
      component={component}
    >
      {text}
    </Button>
  );
};

export default SecondaryButton;
